<template>
	<div>
		<van-overlay :show="showSelected" z-index="5" @click="showSelected=!showSelected" />
		<div class="pay-div">
			<div v-if="showSelected && getGoodsList.length>0">
				<div class = "selected-title-div">
					<van-row type="flex" justify="space-between">
					  <van-col span="8">
						  已选产品
					  </van-col>
					  <van-col span="8">
						  <div class="clear-div">
							  <van-icon name="delete-o"/> 
							  <span @click="clearCar()">清空</span>
						  </div>
					  </van-col>
					</van-row>
				</div>
				<div class = "selected-goods-div" >
					<div v-for ="(item) in getGoodsList" :key = "item.id">
						<van-row>
					  <van-col span="8">
						  <img class="selected-image" :src="item.thumb"/>
					  </van-col>
					  <van-col span="16">
						  <div class="selected-name">{{item.name}}</div>
						  <div class="selected-specification">{{getSingleSpec(item.specs)}}</div>
						  <div>
							  <van-row type="flex" justify="space-between">
							    <van-col span="6">
							  	  <div class="selected-price">
									  <span>¥</span>
									  <span>{{getSinglePrice(item)}}</span>
								  </div>
							    </van-col>
							    <van-col span="18">
							  	  <div class="selected-count">
							  		  <van-stepper min="0" max = "300" v-model = "item.goodsNum" theme="round" disable-input @change = "updateCount(item.id,item.goodsNum)"/>
							  	  </div>
							    </van-col>
							  </van-row>
						  </div>
					  </van-col>
					</van-row>
					</div>
				</div>
			</div>
			<div class = "pay-money-div" :class="{'pay-money-div-shadow':showSelected == 'false' }">
				<van-row>
					<van-col span="4">
						<div class="pay-logo" @click="showSelected=!showSelected">
							<img src="../../assets/backage_img.jpg"/>
						</div>
					</van-col>
					<van-col span="20">
						<div class="pay-detail-div">
							<van-row>
								<van-col span="16">
									<div class="pay-price">
										<div>
											<span>¥</span>
											<span>{{parseFloat(getPrice+'').toFixed(2)}}</span>
											<span v-show = "getOfficalPrice>0">¥{{parseFloat(getOfficalPrice+'').toFixed(2)}}</span>
										</div>
										<div v-show = "getOfficalPrice - getPrice>0">已省{{parseFloat(getOfficalPrice - getPrice).toFixed(2)}}元</div>
									</div>
								</van-col>
								<van-col span="8">
									<div class="pay-button-div">
										<van-button round color="#2e6c43" :disabled="getPrice<=0" to="pay">去结算</van-button>
									</div>
								</van-col>
							</van-row>
							
						</div>
					</van-col>
				</van-row>
			</div>
		</div>
	</div>
</template>

<script>
	import {editShopCar,clearShopCar} from '@/request/api';
	import {Col, Row,Button,Icon,Overlay,Stepper } from 'vant';
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'ComPayDetail',
		computed: mapGetters(["getPrice","getOfficalPrice","getGoodsList","sShop"]),
		components: {
		      [Col.name]: Col,
		      [Row.name]: Row,
		      [Button.name]: Button,
		      [Icon.name]: Icon,
		      [Overlay.name]: Overlay,
		      [Stepper.name]: Stepper,
		      
		 },
		data(){
			return {
				showSelected:false
			}
		},
		methods:{
			...mapMutations(['deleteGoodsList','clearGoodsList']),
			getSingleSpec(specs){
				let specText = ''
				if(specs){
					for(let spec of specs){
						if(specText){
							specText = specText + "/";
						}
						specText = specText + spec.itemName;
					}
				}
				return specText;
			},
			getSinglePrice(goods){
				// console.log(goods)
				let price = goods.price;
				if(goods.specs){
					for(let spec of goods.specs){
						price = price + spec.upPrice;
					}
				}
				// console.log('sdifjij',price);
				price = parseFloat(price).toFixed(2)
				return price;
			},
			updateCount(id,goodsNum){
				if(goodsNum <= 0){
					this.deleteGoodsList(id)
				}
				let data = {
					goodsNum : goodsNum,
					id : id
				}
				editShopCar(data).then(res => {
					
				}) 
			},
			clearCar(){
				this.clearGoodsList();
				clearShopCar({
					shopName:this.sShop.shopName,
					location:this.sShop.lonAndLat
				}).then(res => {
					
				}) 
				
			}
			
		}
	}
</script>

<style scoped>
	.pay-div {
		z-index: 6;
		position: fixed;
		width: 100%;
		bottom: 0px;
		left: 0px;
	}

	
	.pay-money-div-shadow {
		box-shadow: 0 2px 10px #c5c5c5;
	}
	
	
	.pay-money-div {
		border-top-color: #c5c5c5;
		padding: 6px 6px 8px 0;
		width: 100%;
		background-color: #ffffff;
	}
	
	.pay-logo>img{
		width: 35px;
		height: 35px;
		display: block;
		margin: 0 auto;
		margin-top: 5px;
	}
	
	.pay-price span:nth-child(1) {
		font-size: 16px;
		color: #000000;
	}
	.pay-price span:nth-child(2) {
		font-size: 20px;
		color: #000000;
	}
	.pay-price span:nth-child(3) {
		font-size: 10px;
		margin-left: 10px;
		color: #666666;
		text-decoration: line-through;
	}
	
	.pay-price div:last-child {
		color: #666666;
		font-size: 12px;
	}
	
	.pay-button-div .van-button{
		font-size: 15px;
		margin-top: 3px;
		min-width: 80px;
		height: 35px;
		float: right;
	}
	
	.selected-title-div {
		background-color: #f0f0f0;
		padding: 10px;
	}
	
	.selected-title-div>.van-row--justify-space-between>div:nth-child(1) {
		font-size: 13px;
		color: #343434;
		
	}
	.selected-title-div>.van-row--justify-space-between>div:nth-child(2) {
		font-size: 13px;
		color: #343434;
		text-align: right;
	}
	.clear-div {
		display: inline-flex;
		align-items: center;
	}
	
	.selected-goods-div {
		padding: 8px 10px;
		background-color: #ffffff;
		max-height: 380px;
		overflow-y: auto;
	}
	
	.selected-image {
		width: 70px;
		height: 70px;
		display: block;
		margin: 0 auto;
	}
	
	.selected-name {
		padding-bottom: 5px;
		color: #343434;
		font-size: 17px;
	}
	.selected-specification {
		padding-bottom: 3px;
		color: #656565;
		font: 14px;
	}
	
	.selected-price>span:first-child {
		color: #c8544a;
		font-size: 14px;
		font-weight: 570;
	}
	.selected-price>span:last-child {
		color: #c8544a;
		font-size: 16px;
		font-weight: 570;
	}
	.selected-count {
		text-align: right;
		margin-right: 10px;
	}
	
	.selected-count /deep/ button:first-child {
		width: 17px;
		height: 17px;
		color: #2e6c43;
		border-color: #2e6c43;
	}
	.selected-count /deep/ button:last-child {
		width: 17px;
		height: 17px;
		background-color: #2e6c43;
		border-color: #2e6c43;
	}
</style>
